import { App } from 'vue';
import VueToastification from 'vue-toastification';

export default (app: App): void => {
  app.use(VueToastification, {
    toastClassName: 'clearstream-toast',
    maxToasts: 5,
    draggable: false,
    newestOnTop: false,
    closeButton: false,
    closeOnClick: true,
    icon: false,
    transition: 'toast-fade',
    pauseOnHover: false,
    hideProgressBar: true,
    shareAppContext: true,
  });
};
